module.exports = __webpack_public_path__ + "img/logo.cb98d2f3.png";